import React, { Component } from 'react'
import { Project, Subcategory } from 'types'
import { Grid, Col, Row, Modal } from 'react-bootstrap'
import Button from 'components/CustomButton/CustomButton'
import { __, T } from 'config/i18n'
import FormInputs, { CustomFormControlProps } from 'components/FormInputs/FormInputs'
import TableView from 'views/common/TableView'
import { Medias, Explorecards } from 'api'
import { View, UploadImageBox } from 'components/Common'
import { normalizeMedia } from 'utils'

interface Props {
  project: Project
  refreshCallback: () => void
}
interface State {
  showModal: boolean
  explorecard: any
  showImageModal: boolean
}

class ExploreCardTable extends TableView {
  title = __(T.title.explorecards)
  resource = new Explorecards()
  columns = [{ label: __(T.form.title), name: 'index' }]
  defaultColumns = [this.imageableColumn, this.editableColumn, this.deletableColumn]
}

export default class ExploreCardTab extends Component<Props, State> {
  explorecardResource = new Explorecards()
  state: State = {
    showModal: false,
    explorecard: {},
    showImageModal: false,
  }

  properties: CustomFormControlProps[] = [
    {
      label: 'id',
      disabled: true,
    },
    {
      label: 'icon',
      required: true,
    },
    {
      label: 'online_button_link',
      required: true,
    },
  ]

  onDetailClick = (item?: any) => {
    this.setState({ explorecard: item || {} })
    this.handleShow()
  }

  onImageableClick = (item?: any) => {
    this.setState({ explorecard: item || {}, showImageModal: true })
  }

  handleClose = () => this.setState({ showModal: false })
  handleShow = () => this.setState({ showModal: true })

  saveClose = async () => {
    const { refreshCallback, project } = this.props
    const { explorecard } = this.state

    if (!explorecard) return
    let res
    if (explorecard.id) {
      res = await this.explorecardResource.edit(explorecard.id, explorecard)
    } else {
      explorecard.project_id = project.id!
      res = await this.explorecardResource.save(explorecard)
    }
    if (res.success) {
      await this.setState({ showModal: false })
      await refreshCallback()
    }
  }

  // onCheckPress = (index: number) => {
  //   const { project } = this.props
  //   const { macro } = this.state
  //   if (project.subcategories[index].macro_id === macro.id) {
  //     project.subcategories[index].macro_id = undefined
  //   } else {
  //     project.subcategories[index].macro_id = macro.id
  //   }
  //   this.forceUpdate()
  // }

  // onSubClick = (subSelected: Subcategory) => {
  //   const { project } = this.props
  //   const { macro } = this.state

  //   let subcategory = project.subcategories.find((x) => x.id === subSelected.id)!

  //   if (subcategory.macro_id === macro.id) {
  //     subcategory.macro_id = subcategory.old_macro_id
  //   } else {
  //     subcategory.old_macro_id = subcategory.macro_id
  //     subcategory.macro_id = macro.id
  //   }
  //   this.forceUpdate()
  // }

  onMediaSave = async () => {
    const { project } = this.props
    const { explorecard } = this.state
    let promises = explorecard.media
      ?.filter((m: any) => m.media && typeof m.media !== 'string')
      .map(async (x: any) => {
        x.id = (await Medias.upload(project.id!, x)).id
      })
    promises && (await Promise.all(promises))

    this.setState({ showImageModal: false })
  }

  render() {
    const { project, refreshCallback } = this.props
    const { showModal, explorecard, showImageModal } = this.state

    const editModal = (
      <Modal {...(this.props as any)} show={showModal} dialogClassName={'full-modal'} onHide={this.handleClose}>
        <form
          onSubmit={(e) => {
            e.preventDefault()
            this.saveClose()
          }}
        >
          <Modal.Header closeButton onClick={this.handleClose}>
            <Modal.Title id="contained-modal-title-lg">
              {__(T.title.explorecards)} {explorecard.title ? `"${explorecard.title}"` : ''}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <FormInputs
                    data={explorecard}
                    ncols={[...this.properties!.map((p) => p.ncols || 'col-md-12')]}
                    properties={this.properties}
                  />
                </Col>
              </Row>
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="warning" fill onClick={this.handleClose}>
              Chiudi
            </Button>
            <Button bsStyle="info" fill type={'submit'}>
              Salva
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    )

    const imageModal = explorecard.media ? (
      <Modal
        dialogClassName="custom-dialog"
        show={showImageModal}
        onHide={() => this.setState({ showImageModal: false })}
      >
        <Modal.Body>
          <UploadImageBox fileType={'jpg'} medias={normalizeMedia(explorecard, 'explorecard', ['main']).media} />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="warning" fill onClick={() => this.setState({ showImageModal: false })}>
            Chiudi
          </Button>
          <Button bsStyle="info" fill type={'submit'} onClick={this.onMediaSave}>
            Salva
          </Button>
        </Modal.Footer>
      </Modal>
    ) : (
        <View></View>
      )

    return (
      <>
        <ExploreCardTable
          data={project.explorecards}
          onDetailClick={this.onDetailClick}
          title={`${__(T.title.explorecards)} (${project.explorecards.length})`}
          onImageableClick={this.onImageableClick}
          refreshCallback={refreshCallback}
          {...(this.props as any)}
        />
        {editModal}
        {imageModal}
      </>
    )
  }
}
